var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    fill: "white",
    stroke: "#DCF1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9999 21.5061H9V15.0693C9.00002 14.923 9.05815 14.7827 9.16162 14.6792C9.26509 14.5757 9.40542 14.5176 9.55175 14.5176H40.4483C40.5946 14.5176 40.7349 14.5757 40.8384 14.6792C40.9418 14.7827 41 14.923 41 15.0693L40.9999 21.5061Z",
    fill: "#FAB446"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4482 35.4826H9.55175C9.40542 35.4826 9.26509 35.4245 9.16162 35.321C9.05815 35.2175 9.00002 35.0772 9 34.9309V28.4941H40.9999V34.9309C40.9999 35.0772 40.9418 35.2176 40.8383 35.321C40.7349 35.4245 40.5945 35.4826 40.4482 35.4826Z",
    fill: "#73AF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21.5059H40.9999V28.494H9V21.5059Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 27.9662C23.3649 27.9662 22.0347 26.6359 22.0347 25.0007C22.0347 23.3654 23.3649 22.0352 25.0002 22.0352C26.6354 22.0352 27.9657 23.3654 27.9657 25.0007C27.9657 26.6359 26.6354 27.9662 25.0002 27.9662ZM25.0002 22.5868C23.669 22.5868 22.5864 23.6695 22.5864 25.0007C22.5864 26.3318 23.669 27.4145 25.0002 27.4145C26.3313 27.4145 27.414 26.3318 27.414 25.0007C27.414 23.6695 26.3313 22.5868 25.0002 22.5868Z",
    fill: "#41479B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 25.3364C25.1854 25.3364 25.3359 25.1859 25.3359 25.0003C25.3359 24.8146 25.1854 24.6641 24.9998 24.6641C24.8141 24.6641 24.6636 24.8146 24.6636 25.0003C24.6636 25.1859 24.8141 25.3364 24.9998 25.3364Z",
    fill: "#41479B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 25.0504L24.1458 25.1367L22.3105 25.0504V24.9495L24.1458 24.8633L25.0002 24.9495V25.0504ZM25.0002 25.0504L25.8545 25.1367L27.6898 25.0504V24.9495L25.8545 24.8633L25.0002 24.9495V25.0504Z",
    fill: "#41479B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9495 25.0002L24.8633 24.1458L24.9495 22.3105H25.0504L25.1367 24.1458L25.0504 25.0002H24.9495ZM24.9495 25.0002L24.8633 25.8545L24.9495 27.6898H25.0504L25.1367 25.8545L25.0504 25.0002H24.9495Z",
    fill: "#41479B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9644 25.0356L24.2992 24.4926L23.0625 23.1338L23.1338 23.0625L24.4926 24.2992L25.0356 24.9644L24.9644 25.0356Z",
    fill: "#41479B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9644 25.0361L25.5074 25.7012L26.8662 26.938L26.9375 26.8667L25.7007 25.5079L25.0356 24.9648L24.9644 25.0361Z",
    fill: "#41479B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9644 24.9644L25.5074 24.2992L26.8662 23.0625L26.9375 23.1338L25.7008 24.4926L25.0356 25.0356L24.9644 24.9644ZM24.9644 24.9644L24.2992 25.5074L23.0625 26.8662L23.1338 26.9375L24.4926 25.7008L25.0356 25.0356L24.9644 24.9644Z",
    fill: "#41479B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0191 25.0464L24.2627 25.453L22.5342 26.0756L22.4956 25.9824L24.1582 25.2004L24.9805 24.9531L25.0191 25.0464Z",
    fill: "#41479B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0191 25.0463L25.8414 24.799L27.504 24.017L27.4653 23.9238L25.7368 24.5465L24.9805 24.9531L25.0191 25.0463Z",
    fill: "#41479B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9536 25.0196L24.5469 24.2632L23.9243 22.5347L24.0175 22.4961L24.7995 24.1587L25.0468 24.981L24.9536 25.0196Z",
    fill: "#41479B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9531 25.0191L25.2004 25.8414L25.9824 27.504L26.0756 27.4653L25.453 25.7368L25.0464 24.9805L24.9531 25.0191Z",
    fill: "#41479B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9805 25.0463L24.1582 24.799L22.4956 24.017L22.5342 23.9238L24.2627 24.5465L25.0191 24.9531L24.9805 25.0463ZM24.9805 25.0463L25.7369 25.453L27.4654 26.0756L27.504 25.9824L25.8414 25.2004L25.0191 24.9531L24.9805 25.0463Z",
    fill: "#41479B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9531 24.981L25.2004 24.1587L25.9824 22.4961L26.0756 22.5347L25.453 24.2632L25.0464 25.0196L24.9531 24.981Z",
    fill: "#41479B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9536 24.9805L24.5469 25.7368L23.9243 27.4653L24.0175 27.504L24.7995 25.8414L25.0468 25.0191L24.9536 24.9805Z",
    fill: "#41479B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 25.4539C25.2503 25.4539 25.4534 25.2508 25.4534 25.0004C25.4534 24.7499 25.2503 24.5469 24.9999 24.5469C24.7494 24.5469 24.5464 24.7499 24.5464 25.0004C24.5464 25.2508 24.7494 25.4539 24.9999 25.4539Z",
    fill: "#F5F5F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25.2724C25.1502 25.2724 25.2719 25.1506 25.2719 25.0005C25.2719 24.8503 25.1502 24.7285 25 24.7285C24.8498 24.7285 24.728 24.8503 24.728 25.0005C24.728 25.1506 24.8498 25.2724 25 25.2724Z",
    fill: "#41479B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.1d2148397f419f07331f6a00bc1dff46.svg";
export { ForwardRef as ReactComponent };